import { DateTime } from 'luxon';
import type { SagaIterator } from 'redux-saga';
import { delay, put, select } from 'redux-saga/effects';

import { getCurrentDateString } from './dateSelectors';
import { dateActions } from './slice';

const DELAY = 1000 * 60; // dispatch every minute

function* dateWatcher(): SagaIterator {
  // every minute, check that the current date in the store is correct, if not updated it.
  while (true) {
    yield delay(DELAY);
    const current = DateTime.local().toISODate();
    const stored: string = yield select(getCurrentDateString);
    if (current && stored !== current) {
      yield put(dateActions.updateCurrentDate(current));
    }
  }
}

export default [dateWatcher];
